import React from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { MessageComposer } from './MessageComposer'
import { StreamingNote } from '@/types/unlock'

interface IMessageComposer {
  applicationId: number
  applicationExternalId?: string
  createStreamingNote: (note: Partial<StreamingNote>) => Promise<unknown>
  isCreatingStreamingNote?: boolean
  parentStreamingNoteId?: number
  primaryApplicantProfileId?: number
  placeholder?: string
}

export function MessageComposerDnD(props: IMessageComposer) {
  return (
    <DndProvider backend={HTML5Backend}>
      <MessageComposer {...props} />
    </DndProvider>
  )
}
